// @flow
import { SeccionesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    seccion: {},
    listaSecciones: [],
    loading: false,
    error: false,
    formSubmited: false
};

type SeccionesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { seccion?: {} | null, listaSecciones?: [] | null, loading?: boolean, +value ?: boolean };

const Secciones = (state: State = INIT_STATE, action: SeccionesAction): any => {
    // console.log(action);
    switch (action.type) {
        case SeccionesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case SeccionesActionTypes.GET_SECCION: {
                    return {
                        ...state,
                        seccion: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case SeccionesActionTypes.LIST_SECCIONES: {
                    return {
                        ...state,
                        listaSecciones: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case SeccionesActionTypes.ADD_SECCION: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeccionesActionTypes.UPDATE_SECCION: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeccionesActionTypes.DELETE_SECCION: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case SeccionesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case SeccionesActionTypes.GET_SECCION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        seccion: {},
                        loading: false,
                    };
                }
                case SeccionesActionTypes.LIST_SECCIONES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaSecciones: [],
                        loading: false,
                    };
                }
                case SeccionesActionTypes.ADD_SECCION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeccionesActionTypes.UPDATE_SECCION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeccionesActionTypes.DELETE_SECCION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case SeccionesActionTypes.GET_SECCION:
            return { ...state, error: false, loading: true };
        case SeccionesActionTypes.LIST_SECCIONES:
            return { ...state, error: false, loading: true };
        case SeccionesActionTypes.ADD_SECCION:
            return { ...state, error: false, loading: true };
        case SeccionesActionTypes.UPDATE_SECCION:
            return { ...state, error: false, loading: true };
        case SeccionesActionTypes.DELETE_SECCION:
            return { ...state, error: false, loading: true };
        case SeccionesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                seccion: {},
                listaSecciones: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Secciones;
